// The investigation page and the ticket page are different routes, so "Use draft reply" leaves
// the draft here for the ticket page's composer to pick up once. sessionStorage keeps it across the
// navigation in case the page reloads; the in-memory copy covers browsers that refuse storage.
const pending = new Map<string, string>()
const key = (ticketId: string) => `support-agent-draft:${ticketId}`

export const DRAFT_LABEL = 'Drafted by Support Agent'

export function handOffDraft(ticketId: string, text: string): void {
  pending.set(ticketId, text)
  try {
    sessionStorage.setItem(key(ticketId), text)
  } catch {
    // storage unavailable: the in-memory copy is enough for an in-app navigation
  }
}

export function takeDraft(ticketId: string): string | null {
  let text = pending.get(ticketId) ?? null
  pending.delete(ticketId)
  try {
    text = text ?? sessionStorage.getItem(key(ticketId))
    sessionStorage.removeItem(key(ticketId))
  } catch {
    // storage unavailable
  }
  return text
}
